import { IProductsChangeData } from 'legacy/lut/components/widgets/public/partner360/reports/completenessReports/components/filters/components/formProductsSelect/components/productsSelect/models'

import { IReportPeriod } from 'partner360/models/report/iReportPeriod'

import { HpPartnerTypes } from '../commonComponents/pureHpPartnersFilter/configs'
import { AcknowledgedStatus } from '../models'

import { ObligatoryFillIn } from './components/filters/inReportToggle'
import { ReportViewModes } from './components/reportViewSelector/models/reportViewModes'

export enum SubmittedStatus {
  All = -1,
  NotInput = 0,
  SubmittedQ1 = 1,
  SubmittedQ2 = 2,
  SubmittedQ3 = 3,
  SubmittedQ4 = 4,
}

export interface ISobAnalyticsFilterApplied {
  ProgramType?: string | null
  Category?: string | null
  SubCategory?: string | null

  GeoMarket?: string[]
  CountryCode?: string[]

  PBMEmail?: string
  ManagerEmail?: string
  PartnerType?: string[]
  ExcludePartnerTypes?: string[]
  GlobalPartnerId?: string[]
  AcknowledgedStatus?: AcknowledgedStatus
  ObligatoryFillIn?: ObligatoryFillIn
  SubmittedStatus?: SubmittedStatus
  PartnerId?: string[]
  PartnerSpecialization?: string[]
  AmplifyTrack?: string[]
  HpPartnerType?: HpPartnerTypes | ''
  Organization?: string[]
}

export interface ISobAnalyticsFiltersFormData {
  countryCode: string[]
  pbmEmail: string
  managerEmail: string
  globalPartnerId: string[]
  acknowledgedStatus: AcknowledgedStatus
  obligatoryFillIn: ObligatoryFillIn
  submittedStatus: SubmittedStatus
  partnerId: string[]
  hpPartnerType: HpPartnerTypes | ''
  products: IProductsChangeData
  partnerSpecs: string[]
  partnerTypes: string[]
  excludePartnerTypes: string[]
  amplifyTrack: string[]
  organizations: string[]
  // report view options
  reportViewMode: ReportViewModes
  reportViewPeriod?: IReportPeriod
}
